import { IconComponentProps } from '../IconTypes';

const MenuCollapse = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.875 4.5C3.52984 4.5 3.25 4.77969 3.25 5.125C3.25 5.47031 3.52984 5.75 3.875 5.75H17.125C17.4688 5.75 17.75 5.47031 17.75 5.125C17.75 4.77969 17.4688 4.5 17.125 4.5H3.875Z"
      fill="currentColor"
    />
    <path
      d="M3.875 10.75C3.52984 10.75 3.25 11.0312 3.25 11.375C3.25 11.7188 3.52984 12 3.875 12H12.125C12.4688 12 12.75 11.7188 12.75 11.375C12.75 11.0312 12.4688 10.75 12.125 10.75H3.875Z"
      fill="currentColor"
    />
    <path
      d="M3.875 18.25H17.125C17.4688 18.25 17.75 17.9688 17.75 17.625C17.75 17.2812 17.4688 17 17.125 17H3.875C3.52984 17 3.25 17.2812 3.25 17.625C3.25 17.9688 3.52984 18.25 3.875 18.25Z"
      fill="currentColor"
    />
    <path
      d="M20.5661 15.3087L16.6326 11.3751L20.5661 7.44153C20.8103 7.19739 20.8103 6.80169 20.5661 6.55794C20.322 6.31419 19.9263 6.3138 19.6826 6.55794L15.3076 10.9329C15.1872 11.0548 15.1247 11.215 15.1247 11.3751C15.1247 11.5353 15.1858 11.695 15.3079 11.8169L19.6829 16.1919C19.927 16.4361 20.3227 16.4361 20.5665 16.1919C20.8102 15.9478 20.8122 15.5509 20.5661 15.3087Z"
      fill="currentColor"
    />
  </svg>
);

export default MenuCollapse;
